import { Enum } from "./Enum";

export const ChainOperatorEnum: Enum[] = [
  { id: '&&', name: 'i' },
  { id: '||', name: 'ili' }
];